import AddressBookGridContainer from './addressBookGridContainer';

export default AddressBookGridContainer;